/* eslint-disable no-shadow */
/* eslint-disable react/no-deprecated */
import React, { Component } from 'react'
import { Modal, message, Spin, Input, Button, ConfigProvider, Popover } from 'antd'
import classnames from 'classnames'
import qs from 'qs'
import zh_CN from 'antd/lib/locale-provider/zh_CN'
import aliwangwang from '../../../image/aliwangwang.png'
import shopimage from '../../../image/shop.png'
import Checkbox from '../../../baseComponent/checkbox'
import request from '../../../utils/request'
import link from '../../../utils/link'
import { PLATFORM_VALUE } from '../../platformConfig'
import AddInspirationModal from '../../addInspirationModal'
import createGroupModal from './createGroupModal'
import './index.less'
import Icon from '../../icon'
import userInfo from '../../../common/userInfo'

export default class Verb extends Component {
  constructor(props) {
    super(props)
    this.state = {
      itemUrl: '',
      resultStatus: '',
      followFlag: false,
      isShowResult: false,
      type: props.title === '店铺' ? 'shop' : 'item',
      info: {},
      itemId: '',
      groups: [],
      collectLimit: 0,
      loading: false,
      collectVisible: false
    }
    this.isShop = props.title === '店铺'
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.title !== this.props.title) {
      this.setState({
        type: nextProps.title === '店铺' ? 'shop' : 'item',
        resultStatus: '',
        followFlag: '',
        itemId: '',
        isShowResult: false
      })
      this.isShop = nextProps.title === '店铺'
    }
  }

  onItemClick(item) {
    const { groups } = this.state
    // eslint-disable-next-line no-param-reassign
    item.checked = !item.checked
    this.setState({ groups })
  }

  // 添加进分组
  async onAddToGroup() {
    const { groups } = this.state
    const groupIds = groups.filter(item => item.checked).map(item => item.groupId).join(',')
    this.setState({ loading: true })
    const res = await request.get('shop/unknown-shop-add-groups', { params: { groupIds, itemId: this.state.itemId } })
    this.setState({ loading: false })
    if (res) {
      this.setState({ isShowResult: false })
      this.onClose()
    }
  }

  // 点击「添加分组」按钮
  onAddGroupClick = async () => {
    // 打开「添加分组」弹框
    const res = await createGroupModal.show()
    if (res) {
      const res = await request.get('group/type-group-list-new')
      const { myGroupList = [], teamGroupList = [] } = res
      const groups = myGroupList.filter(item => item?.groupId > 0).concat(teamGroupList.filter(item => item?.groupId > 0))
      this.setState({ groups })
    }
  }

  async onOk() {
    const { itemUrl, type } = this.state
    this.setState({ loading: true })
    if (!itemUrl) {
      message.error('请输入正确的链接地址')
      return
    }
    await this.props?.getVerbInfo({ itemUrl, type }).then(async (data) => {
      if (!data) {
        this.setState({ loading: false })
        return
      }
      const { status, followFlag, collectFlag, itemId } = data
      this.props.onGetInfo?.()
      if (status === 3) { // 提交收录请求成功
        const res = await request.get('group/type-group-list-new')
        const { myGroupList = [], teamGroupList = [] } = res
        const groups = myGroupList.filter(item => item?.groupId > 0).concat(teamGroupList.filter(item => item?.groupId > 0))
        this.setState({ groups })
        const data = await request.get('/monitor-item/get-user-monitor-info')
        const { maxShopMonitorLimit, shopMonitorCount } = data
        this.setState({ collectLimit: maxShopMonitorLimit - shopMonitorCount })
      }
      this.setState({ resultStatus: status, followFlag: this.isShop ? followFlag : collectFlag, loading: false, isShowResult: true, itemId })
    })
  }

  async onCollect() {
    const { itemUrl, type } = this.state
    const search = itemUrl.replace(/^http.*\?/, '')
    const query = qs.parse(search)
    if (!query.id) {
      message.error('请输入正确的链接地址')
    }
    this.props?.getVerbInfo({ itemUrl, type })
    const fetchItemDetail = async () => {
      const res = await request.get('/item/origin/info', { params: { itemId: query.id } })
      return {
        itemOriginDTO: res.itemOriginDTO,
        platformId: PLATFORM_VALUE.ITEM,
        imageGroupEntityId: query.id,
        mainUrl: res.itemOriginDTO?.picUrl,
        itemDataDTO: {
          ...(res.itemOriginDTO || {}),
          price: res.itemOriginDTO?.cprice,
        }
      }
    }
    try {
      const info = await fetchItemDetail()
      this.props.onGetInfo?.()
      this.setState({ info, collectVisible: true })
    } catch (err) {
      message.error(err.errorDesc)
    }
  }

  onClose() {
    this.setState({ isShowResult: false, itemUrl: '' })
    this.props.close()
  }

  onVisit(id) {
    if (this.isShop) {
      link.toShopDetail(id)
    } else {
      link.toGoodDetail(id)
    }
  }

  async onMonit(type, id) {
    if (this.isShop) {
      await request.changeShopCollect(type, id).then((res) => {
        if (res) {
          this.setState({ followFlag: true })
          message.success('操作成功')
          window.location.reload()
        }
      }).catch((m) => {
        message.warning(m.errorDesc)
      })
    } else {
      await request.changeItemCollect(type, id).then((res) => {
        if (res) {
          this.setState({ followFlag: true })
          message.success('操作成功')
          window.location.reload()
        }
      }).catch((m) => {
        message.warning(m.errorDesc)
      })
    }
  }

  onInput(e) {
    this.setState({ itemUrl: e.target.value })
  }

  renderVerbed() {
    const { title, verbInfo: { shopInfo, itemInfo, recordDate } } = this.props
    let info = {}
    if (this.isShop) {
      info = {
        logo: shopInfo.shopLogo,
        name: shopInfo.shopName,
        sellerName: shopInfo.sellerName,
        monthlyNewItemCount: shopInfo.monthlyNewItemCount,
        monthSalesVolume: shopInfo.monthSalesVolume,
      }
    } else {
      info = {
        logo: itemInfo.picUrl,
        name: itemInfo.title,
        sellerName: itemInfo.sellerName,
        shopName: itemInfo.shopName,
        monthlyNewItemCount: itemInfo.sale30DayInsertTime,
        monthSalesVolume: itemInfo.sale30day,
        curCprice: itemInfo.curCprice
      }
    }
    return (
      <div>
        <div className="verb-ed">该{title}已被收录，收录日期{recordDate}</div>
        <div className="verb-shopinfo">
          {
              info.logo
                ? <img src={info.logo} alt="" className="verb-shop-logo" />
                : <div className="verb-shop-logo">{info.name[0]}</div>
            }
          <div className="verb-right">
            <div className="v-shop-name">{info.name}</div>
            {this.isShop
              ? <div className="v-seller-name"><img className="aliwangwang" src={aliwangwang} alt="aliwangwang" />{info.sellerName}</div>
              : <div className="v-seller-name"><img className="aliwangwang" src={shopimage} alt="aliwangwang" />{info.shopName}</div>}
          </div>
          {!this.isShop
              && <div className="v-shop-price">
                <span>￥{(info.curCprice / 100).toFixed(2)}</span>
              </div>}
        </div>
        <div className="verb-num-wrap">
          {this.isShop
            ? <div className="verb-num">
              {info.monthlyNewItemCount}
              <div>近30天上新</div>
            </div> : ''}
          <div className="verb-num">
            {info.monthSalesVolume}
            <div>近30天销量</div>
          </div>
        </div>
      </div>
    )
  }

  renderWillVerbe() {
    const { verbInfo: { displayDate, recordDate }, title } = this.props
    return (
      <div className="verb-will">
        <div>该{title}已于{recordDate}提交收录<br />我们将于{displayDate}日呈现该{title}数据。</div>
        <div className="info">店铺收录初期数据可能出现误差或缺失，敬请谅解</div>
      </div>
    )
  }

  renderCommitVerbe() {
    const { verbInfo: { displayDate }, title } = this.props
    const { groups } = this.state
    return (
      <div className="verb-will">
        <div className="title">
          <div className="success-icon-wrapper">
            <Icon className="success-icon" type="m-xiaoyan_tianchong" style={{ color: '#4ed784' }} />
          </div>
          <div style={{ margin: '16px 0' }}>提交成功</div>
        </div>
        <div>
          感谢你的提交，我们将于<span className="dateTime">{displayDate}</span>日呈现该{title}数据
          <Popover
            placement="bottomLeft"
            arrowPointAtCenter
            overlayClassName="tooltip"
            getPopupContainer={() => document.querySelector('.zyshuoming')}
            content={<div style={{ padding: '20px 4px', fontSize: '13px', fontWeight: 400, color: 'var(--m-text-3)' }}>店铺收录初期数据可能出现误差或缺失，敬请谅解。</div>}
          >
            <Icon className="zyshuoming" type="m-shuoming" style={{ fontSize: '12px', marginLeft: '8px' }} />
          </Popover>
        </div>
        {/* <div className="info">店铺收录初期数据可能出现误差或缺失，敬请谅解</div> */}
        <div className="groups-wrapper">
          <div className="title">
            <div className="group-tips">请选择您需要加入的分组</div>
            <a className="new-group" onClick={() => { this.onAddGroupClick() }}>+新建分组</a>
          </div>
          <div className="group-list">
            {groups.map((item) => {
              return (
                <div className="group-item">
                  <Checkbox
                    style={{ display: 'flex', alignItems: 'center' }}
                    checked={item.checked}
                    onChange={() => { this.onItemClick(item) }}
                  >
                    {item.groupName.length > 10
                      ? <Popover
                          placement="bottomLeft"
                          arrowPointAtCenter
                          getPopupContainer={() => document.querySelector('.group-list')}
                          content={<div style={{ padding: '10px 4px', fontSize: '13px', fontWeight: 400, color: 'var(--m-text-3)' }}>{ item.groupName }</div>}
                      >
                        <span className="checkbox-label" style={{ position: 'relative' }}>
                          <span className={classnames('checkbox-label-text', { checked: item.checked })} style={{ display: 'inline-block', width: '90px', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', marginTop: '5px', textAlign: 'left' }}>{item.groupName}</span>
                        </span>
                      </Popover>
                      : <span className="checkbox-label" style={{ position: 'relative' }}>
                        <span className={classnames('checkbox-label-text', { checked: item.checked })} style={{ display: 'inline-block', width: '90px', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', marginTop: '5px', textAlign: 'left' }}>{item.groupName}</span>
                      </span>}
                  </Checkbox>
                </div>
              )
            })}
          </div>
        </div>
        <div className="collect-limit-wrapper">
          <div className="limit">当前剩余监控额度： <span className={classnames({ warning: this.state.collectLimit < 1 })}>{this.state.collectLimit}</span></div>
          <div className="limit-tips">*预留监控额度可保证收录后的店铺数据正常更新</div>
        </div>
      </div>
    )
  }

  renderResult() {
    const { isShowResult, followFlag, resultStatus } = this.state
    // 1-商品已经被收录；2-商品已经提交收录；3-提交收录请求成功
    if (resultStatus === 1) {
      const { verbInfo: { shopInfo, itemInfo, } } = this.props
      if ((this.isShop && !shopInfo) || (!this.isShop && !itemInfo)) {
        return
      }
      const id = this.isShop ? shopInfo.shopId : itemInfo.itemId
      return (
        <Modal
          centered
          title="提示"
          className="verb-container"
          visible={isShowResult}
          width={480}
          footer={[
            <Button key="back" onClick={this.onVisit.bind(this, id)}>访问</Button>,
            <Button key="submit" type="primary" onClick={this.onMonit.bind(this, followFlag, id)}>
              {followFlag ? '取消监控' : '监控'}
            </Button>,
          ]}
          onOk={this.onOk.bind(this)}
          onCancel={this.onClose.bind(this)}
          cancelText="访问"
          okText="监控"
        >
          <div className="verb-context">
            {this.renderVerbed()}
          </div>
        </Modal>
      )
    } if (resultStatus === 3) {
      return <Modal
        centered
        className="verb-container"
        visible={isShowResult}
        width={570}
        bodyStyle={{ paddingBottom: 0 }}
        footer={[
          <Button key="cancel" onClick={() => { this.onClose() }} disabled={this.state.loading}>取消</Button>,
          <Button key="submit" type="primary" onClick={() => { this.onAddToGroup() }} disabled={this.state.loading}>确定</Button>,
        ]}
        onOk={() => { this.onAddToGroup() }}
        onCancel={() => { this.onClose() }}
      >
        <div className="verb-context">
          {this.renderCommitVerbe()}
        </div>
      </Modal>
    }
    return (
      <Modal
        centered
        title="提示"
        className="verb-container"
        visible={isShowResult}
        width={480}
        onOk={this.onClose.bind(this)}
        onCancel={this.onClose.bind(this)}
        cancelText="取消"
        okText="确定"
      >
        <div className="verb-context">
          {resultStatus === 2 && this.renderWillVerbe()}
        </div>
      </Modal>
    )
  }

  render() {
    const { visible, newTitle } = this.props
    const { info, collectVisible } = this.state
    return (
      <ConfigProvider locale={zh_CN}>
        <div>
          <Modal
            centered
            title={newTitle || '新增店铺收录'}
            className="verb-container"
            visible={visible}
            width={480}
            onCancel={this.onClose.bind(this)}
            footer={<>
              <Button type="ghost" onClick={this.onClose.bind(this)} disabled={this.state.loading}>取消</Button>
              {userInfo.isWhalePick ? <Button type="primary" onClick={this.onCollect.bind(this)} disabled={this.state.loading}>直接采买</Button> : null}
              <Button type="primary" onClick={this.onOk.bind(this)} disabled={this.state.loading}>提交</Button>
            </>}
          >
            <Spin spinning={this.state.loading} tip="加载中...">
              <div style={{ position: 'relative' }}>
                <Input.TextArea
                  className="verb-input-textarea"
                  value={this.state.itemUrl}
                  onInput={this.onInput.bind(this)}
                  maxLength={500}
                  placeholder={this.isShop ? '请输入店铺任意一个宝贝的链接，建议使用在售宝贝' : '请输入需要收录的宝贝链接'}
                />
                <span className="textarea-count">{ this.state.itemUrl?.length } / 500</span>
              </div>
              <div className="verb-tips">成功收录店铺后，我们将自动监控该店铺，并将于2日后呈现该店铺数据</div>
            </Spin>
          </Modal>
          {this.renderResult()}
          {collectVisible && <AddInspirationModal
            visible={collectVisible}
            currentViewBlog={info}
            onClose={() => { this.setState({ collectVisible: false }) }}
            userInfo={userInfo}
          />}
        </div>
      </ConfigProvider>
    )
  }
}
